// src/pages/work/WorkLayout.jsx
import { Outlet } from "react-router-dom";

export default function WorkLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
